module.exports = __webpack_public_path__ + "static/logo2-867f625cf675789daa58779f8b18432a.png";